import { useQuery } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import { SiteId } from "@visioni/a3s-schema";
import type { UpsellStatus, UpsellStatusParams } from "../schema";
import { upsellStatusQuery } from "./queries";

const STALE_TIME_MS = 5 * 60_000;

export interface UseUpsellStatusResult {
  readonly upsellStatus: UpsellStatus["upsellStatus"] | null;
  readonly isProductAlreadyActive: boolean;
  readonly isLoading: boolean;
  readonly isError: boolean;
  readonly isTenantPending: boolean;
}

export const useUpsellStatus = (params: UpsellStatusParams): UseUpsellStatusResult => {
  const apiConfig = useApiConfig();

  const queryParams = { product: params.product, siteId: SiteId.fromString(params.siteId) };

  const query = useQuery({
    ...upsellStatusQuery(apiConfig, {}, queryParams),
    staleTime: STALE_TIME_MS,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });

  return {
    upsellStatus: query.data?.upsellStatus ?? null,
    isProductAlreadyActive: query.data?.isProductAlreadyActive ?? false,
    isLoading: query.isLoading,
    isError: query.isError,
    isTenantPending: !apiConfig.tenant,
  };
};
